import React from 'react';
import { useLoadScript, Autocomplete } from '@react-google-maps/api';
import { TextField, CircularProgress } from '@mui/material';

const libraries: ("places")[] = ["places"];

interface AddressAutocompleteProps {
  onSelect: (address: google.maps.places.PlaceResult, placeId: string | undefined, lat: number | undefined, lng: number | undefined) => void;
}

const AddressAutocomplete: React.FC<AddressAutocompleteProps> = ({ onSelect }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const [autocomplete, setAutocomplete] = React.useState<google.maps.places.Autocomplete | null>(null);

  const onLoad = (autoC: google.maps.places.Autocomplete) => {
    setAutocomplete(autoC);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const placeId = place.place_id;
      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();
      onSelect(place, placeId, lat, lng);
    }
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <CircularProgress />;

  return (
    <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
      <TextField
        fullWidth
        label="Search business"
        variant="outlined"
      />
    </Autocomplete>
  );
};

export default AddressAutocomplete;
